module.exports = __webpack_public_path__ + "static/media/Hombre.99120aa2.png";